<!-- 弹窗容器 -->
<template>
  <div>
    <!-- 登录弹窗 -->
    <DialogLogin :visible="dialogLoginVisible" />
    <!-- 注册弹窗 -->
    <DialogRegister :visible="dialogRegisterVisible" />
    <!-- 图片弹窗 -->
    <DialogImage :visible="dialogImageVisible" :detail="dialogImageDetail" />
  </div>
</template>

<script>
import { EventBus } from '@/utils/eventbus';
import { fileDownload } from '@/utils/tool';

import DialogLogin from '@/dialogs/DialogLogin.vue';
import DialogRegister from '@/dialogs/DialogRegister.vue';
import DialogImage from '@/dialogs/DialogImage.vue';

export default {
  name: 'DialogContainer',
  components: {
    DialogLogin,
    DialogRegister,
    DialogImage,
  },
  data() {
    return {
      dialogLoginVisible: false, // 登录弹窗可见性
      dialogRegisterVisible: false, // 注册弹窗可见性
      dialogImageVisible: false, // 图片弹窗可见性
      dialogImageDetail: {}, // 图片弹窗详情
    };
  },
  methods: {
    fileDownload,
  },
  mounted() {
    EventBus.$on('dialogLoginVisible', (e) => {
      this.dialogLoginVisible = e;
    });
    EventBus.$on('dialogRegisterVisible', (e) => {
      this.dialogRegisterVisible = e;
    });
    EventBus.$on('dialogImageVisible', (e, detail) => {
      this.dialogImageVisible = e;
      this.dialogImageDetail = detail;
    });
  },
};
</script>

<style lang="scss" scoped></style>
